export default __webpack_public_path__ + "9cd0573c12ffbd31866215ed7af20b76.svg";